
<script setup>import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import { formatTimestamp } from '@/utils/other'
import { getBannerApi, getSimpleListApi, getNewsArticleTypeApi } from "@/api";

const route = useRoute();
const router = useRouter();
const bannerList = ref([]);
let type = router.currentRoute.value.query.type;
const pageSize = ref(10);
const newsList = ref([]);
const newsSubItems = ref([]);
const activeItem = ref({});
const total = ref(0);
const pageNo = ref(1);
let observer = null;

// 设置新闻列表项的观察器
function setupNewsListObserver() {
  if (observer) {
    observer.disconnect()
  }

  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate__fadeInUp')
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
  )

  // 观察所有新闻列表项
  const newsElements = document.querySelectorAll('#newsList li')
  newsElements.forEach(el => {
    observer.observe(el)
  })
}

function getBanner() {
  getBannerApi({ type: 1 }).then(res => {
    bannerList.value = res.data
  })
}

function pageChange(page, e) {
  console.log(page, e)
  pageNo.value = page
  getNewsArticleType()
}

async function getHome() {
  await getSimpleListApi({ type: 5 }).then(res => {
    newsSubItems.value = res.data
    if (type) {
      activeItem.value = newsSubItems.value.find(item => item.id == type)
    } else {
      activeItem.value = newsSubItems.value[0]
    }
  })
  console.log(activeItem.value)
  getNewsArticleType()
}

function getNewsArticleType() {
  getNewsArticleTypeApi({
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    type: 5,
    categoryId: activeItem.value.id
  }).then(res => {
    newsList.value = res.data.list
    total.value = res.data.total

    // 数据更新后重新设置观察器
    nextTick(() => {
      setTimeout(() => {
        setupNewsListObserver()
      }, 100)
    })
  })
}

function switchItem(item) {
  activeItem.value = item
  pageNo.value = 1
  getNewsArticleType()
}

function goDetails(id) {
  router.push({
    path: `/newsDetails`,
    query: { id }
  })
}

// 监听路由参数变化
watch(
    () => route.query.type,
    (newType) => {
      console.log(newType)
      type = newType
      getHome();
    }
);

onMounted(() => {
  // 组件挂载后设置观察器
  nextTick(() => {
    setTimeout(() => {
      setupNewsListObserver()
    }, 100)
  })
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})

getBanner()
getHome()
</script>

<template>
  <HeaderNav :isCurrent="4" />
  <div class="box">
    <!-- 轮播图 -->
    <el-carousel height="600px" autoplay>
      <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
        <img :src="item.picUrl" :alt="item.title">
      </el-carousel-item>
    </el-carousel>
    <div>
      <div class="article">
        <!-- 右侧区域 开始 -->
        <div id="right">
          <div class="right_title">
            <!-- 当前位置 -->
            <div id="location">
              <a href="/" target="_self">{{ t('首页') }}</a> &nbsp;&gt;&gt;&nbsp;
              <a href="javascript:;"> {{t('新闻资讯')}} </a> &nbsp;&gt;&gt;&nbsp;
              <a href="javascript:;">{{activeItem.name}}</a>
            </div>
          </div>

          <div id="subchannel_main">
            <div id="subchannel">
              <ul class="subchannellist">
                <li class="depth1  " v-for="item in newsSubItems" :key="item.id" :class="item.id==activeItem.id ? 'current':''" @click="switchItem(item)">
                  <span>{{item.name}}</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="right_body minwidth">
            <ul id="newsList" class="thumblist">
              <li
                  v-for="item in newsList"
                  :key="item.id"
                  @click="goDetails(item.id)"
                  class="pointer animate__animated"
              >
                <div class="InfoPicture">
                  <img
                      :src="item.picUrl"
                      :alt="item.title"
                      :title="item.title"
                  />
                </div>
                <div class="info_wrap">
                  <span class="InfoTitle pointer">{{ item.title }}</span>
                  <p>{{ item.introduction }}</p>
                  <span class="InfoTime">{{ formatTimestamp (item.createTime ,'YYYY-MM-DD' )}}</span>
                  <span class="more pointer">MORE &gt;</span>
                </div>
              </li>
            </ul>

            <div class="page_custom">
              <el-pagination background layout="prev, pager, next" :total="total" @change="pageChange" :default-page-size="pageSize" />
            </div>
          </div>

          <div class="right_bottom"></div>
        </div>
        <!-- 右侧区域 结束 -->
        <div class="clear"></div>
      </div>
    </div>

    <div>
      <FootNav />
    </div>
  </div>
</template>

<style scoped lang="scss">#newsList li {
  opacity: 0;
  transform: translateY(30px);

  &.animate__fadeInUp {
    opacity: 1;
    transform: translateY(0);
    animation-name: fadeInUp;
    animation-duration: 0.6s;
  }
}

.video-details {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  h1 {
    color: #333;
    margin-bottom: 20px;
  }

  .video-container {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>